export default __webpack_public_path__ + "static/media/icon_endtype_SquareClosedEnds.8e8fafd1.png";